import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIe = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "flag-icons-ie",
	viewBox: "0 0 640 480",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		strokeWidth: "1pt",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M0 0h640v480H0z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#009A49",
				d: "M0 0h213.3v480H0z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FF7900",
				d: "M426.7 0H640v480H426.7z"
			})
		]
	})
});
export default SvgIe;
